import React from 'react';


const Projects = () => {
  return (
    <>
    <div className="ui segment">
      <h2>WORK</h2>
      <ul>
      <li><a href="https://fetchnamer.netlify.app/">Fetch!</a></li>
      <li><a href="https://record-collector-epiapp.herokuapp.com/">ReCollector</a></li>
      <li><a href="https://mariosspecialtyfoods.herokuapp.com/">Mario's Specialty foods</a></li>
      <li><a href="https://dev.to/joseykinnaman/the-art-of-debugging-2ooe">Debugging Blog</a></li>
      <li><a href="https://blog.planetargon.com/entries/things-i-learned-as-an-intern-that-i-did-not-learn-in-code-bootcamp">Intern Blog</a></li>
      </ul>
    </div>
    </>
  );
}

export default Projects;